
import interact, { makeNewRestrictedPosition } from "../../interact"
import { useEffect, useMemo, useRef, useState } from "preact/hooks"
import { xMark } from "../../icons.js";
import EssayEditor, { EssayEditorComponent } from "../../../essay-editor/app";

/**
 * @typedef {Object} Options
 * @property {string} storagePrefix
 */

/**
 * @typedef {Options & {questionId: string, close: () => void}} Props 
 */


/**
 * @type {string | undefined}
 */
const initialDataInitialState = undefined;



/**
 * 
 * @param {Props} props 
 */
export default function Notepad(props) {
    /**
     * @type {import("preact").RefObject.<HTMLDivElement>}
     */
    let floatingWindowRef = useRef(null);

    let initialData = useMemo(() => {
        return localStorage.getItem(`${props.storagePrefix}_${props.questionId}`) || ""
    }, [props.questionId, props.storagePrefix])

    useEffect(() => {
        let position = { x: 0, y: 0 };
        interact(".notepad-floating-window").draggable({
            allowFrom: ".notepad-floating-window-header",
            max: 1,
            autoScroll: {
                enabled: true
            },
            listeners: {
                /**
                 * 
                 * @param {import("@interactjs/types").InteractEvent} evt 
                 */
                move: (evt) => {
                    position = makeNewRestrictedPosition(evt, position);
                    if (floatingWindowRef.current) {
                        floatingWindowRef.current.style.transform = `translate(${position.x}px, ${position.y}px)`
                    }
                },
            }
        });

    }, []);

    return <div class="notepad-floating-window floating-window" ref={floatingWindowRef}>
        <div class="notepad-floating-window-header floating-window-header drag-handle">
            <div class="notepad-floating-window-header-title floating-window-header-title">
                Notes
            </div>
            <div class="notepad-floating-window-header-exit floating-window-header-exit" dangerouslySetInnerHTML={{ __html: xMark }} onClick={props.close}></div>
        </div>
        <div class="notepad-editor-container">
            <EssayEditorComponent
                id={props.questionId}
                editorType="basic"
                showEquationEditorButton={false}
                initialData={initialData}
                onAutoSave={(content) => {
                    localStorage.setItem(`${props.storagePrefix}_${props.questionId}`, content)
                }} />
        </div>
    </div>
}